import { useState } from 'react';
import styles from './see-more-see-less.module.scss';
import * as DOMPurify from 'dompurify';

const SeeMoreSeeLessComponent = ({
  htmlContent,
  maxLength,
}: {
  htmlContent: string;
  maxLength: number;
}) => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleTextVisibility = () => {
    setShowFullText(!showFullText);
  };

  const truncatedContent =
    htmlContent && !showFullText ? `${htmlContent.slice(0, maxLength)}` : htmlContent;

  const sanitizedContent = DOMPurify.sanitize(truncatedContent);

  return (
    <div className={styles['container']}>
      <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
      {htmlContent.length > maxLength && (
        <span className={styles['button']} onClick={toggleTextVisibility}>
          {showFullText ? 'See Less' : 'See More'}
        </span>
      )}
    </div>
  );
};

export default SeeMoreSeeLessComponent;
